/* eslint-disable react-hooks/exhaustive-deps */
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap"
import { Fieldset } from "../../../Components/Fieldset/Fieldset"
import AppLayout from "../../../Components/Layout/Layout"
import styled from "styled-components"
import { FormContainer } from "../../../Components/Forms/FormContainer/FormContainer"
import PageTitle from "../../../Components/PageTitle/PageTitle"
import { ButtonSecundary } from "../../../Components/Forms/CancelButton/CancelButton"
import { ButtonPrimary } from "../../../Components/Forms/SaveButton/SaveButton"
import { FormGrid } from "../../../Components/Forms/FormGrid/FormGrid"
import { FormField } from "../../../Components/Forms/FormField/FormField"
import { Label } from "../../../Components/Forms/Label/Label"
import { Input } from "../../../Components/Forms/Input/Input"
import { InputData } from "../../../Components/Forms/InputData/InputData"
import { IEditarLicenca, IFormDataBloquio, ILicencaDto } from "../../../Dtos/Comercial/Licencas/LicencasDtos"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import ApiService from "../../../Config/ApiConfig"
import LoadingPage from "../../../Components/Loading/Loading"
import { IToastOpcoes, Toast } from "../../../Components/Toast/Toast"
import { credencialTemAcesso } from "../../../Components/Layout/MenuData"
import { Table, TableContainer, Td, Th } from "../../../Components/Table/Table"
import { UltAlt } from "../../../Components/UltAlt/UltAlt"

export const FormLicencaPage = () => {
    const { id } = useParams()
    const navigate = useNavigate()

    const [loading, setLoading] = useState<boolean>(false)
    const [toastOpcoes, setToastOpcoes] = useState<IToastOpcoes>({ type: "info", visible: false, mensagem: "" })
    const [inEdicao, setInEdicao] = useState<boolean>(false)
    const [isModalBloquioOpen, setIsModalBloquioOpen] = useState(false);
    const [formData, setFormData] = useState<ILicencaDto>({} as ILicencaDto)
    const [formDataBloquio, setFormDataBloquio] = useState<IFormDataBloquio>({} as IFormDataBloquio)

    useEffect(() => {
        async function checkApi() {
            try {
                const apiService = new ApiService();

                const response = await apiService.get<boolean>("/auth/temAcesso", { params: { tarefa: "Licenças" } })

                if (!response) {
                    navigate("/home");
                }
            } catch (error) {
                navigate("/home");
            }
        }

        checkApi();
    }, []);

    useEffect(() => {
        if (id != null) buscarLicencaPeloId()
    }, [])

    const buscarLicencaPeloId = async () => {
        try {
            setLoading(true)
            const apiService = new ApiService()

            const sd41 = await apiService.get<ILicencaDto>("/sd42Controller/buscarLicencaPeloId", {
                params: {
                    'sd42id': id
                }
            })
            setFormData(sd41);
            setFormDataBloquio({ sd42id: sd41.sd42id!, sd42dtbloqueio: sd41.sd42dtbloqueio, sd42motivobloqueio: sd41.sd42motivobloqueio })
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao buscar a licença \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleChangeBloquio = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormDataBloquio(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleChangeData = (value: string, name: keyof ILicencaDto) => {
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleChangeDataBloqueio = (value: string, name: keyof IFormDataBloquio) => {
        setFormDataBloquio(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleSubmit = async (e: React.FormEvent) => {
        try {
            e.preventDefault();
            setLoading(true)
            if (formData.sd42id == null) throw new Error("ID da licença não encontrado")

            const dados: IEditarLicenca = {
                sd42id: formData.sd42id,
                sd42aquisicao: formData.sd42aquisicao,
                sd42locacao: formData.sd42locacao,
                sd42quantidade: formData.sd42quantidade,
                sd42vencimento: formData.sd42vencimento,
                sd42desconto: formData.sd42desconto,
                sd42relevancia: formData.sd42relevancia,
                sd42servidorsam: formData.sd42servidorsam,
                sd42sampalmandroid: formData.sd42sampalmandroid,
                sd42sampalmios: formData.sd42sampalmios
            }

            const apiService = new ApiService()
            await apiService.post("/sd42Controller/salvarEdicao", dados)

            navigate("/licencas")
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao salvar a licença! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    };

    const handleSubmitBloquio = async (e: React.FormEvent) => {
        try {
            e.preventDefault();
            setLoading(true)
            if (formDataBloquio.sd42id == null) throw new Error("ID da licença não encontrado")

            const apiService = new ApiService()
            await apiService.post("/sd42Controller/bloquear", formDataBloquio)

            setIsModalBloquioOpen(false);
            buscarLicencaPeloId()
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao bloquear a licença! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const handleDesbloquear = async () => {
        try {
            setLoading(true)
            if (formDataBloquio.sd42id == null) throw new Error("ID da licença não encontrado")

            const apiService = new ApiService()
            await apiService.get("/sd42Controller/desbloquear", { params: { sd42id: formDataBloquio.sd42id } })

            setIsModalBloquioOpen(false);
            buscarLicencaPeloId()
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao bloquear a licença! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const handleEdit = () => {
        setInEdicao(true)
    }

    const toggleModalBloquear = () => {
        setFormDataBloquio({ sd42id: formData.sd42id!, sd42dtbloqueio: formData.sd42dtbloqueio, sd42motivobloqueio: formData.sd42motivobloqueio })
        setIsModalBloquioOpen(prev => !prev)
    }

    const handleCancelar = () => {
        setInEdicao(false)
        if (id == null) return
        buscarLicencaPeloId()
    }

    const closeToast = () => {
        setToastOpcoes({ type: "info", visible: false, mensagem: "" })
    }

    if (loading) {
        return (
            <LoadingPage />
        )
    }

    return (
        <AppLayout>
            <Toast
                isVisible={toastOpcoes.visible}
                message={toastOpcoes.mensagem}
                onClose={closeToast}
                type={toastOpcoes.type}
            />
            <PageTitle title='Licença' />
            <FormContainer>
                <form onSubmit={handleSubmit}>
                    <Row>
                        <Col md={6} sm={12}>
                            <Fieldset legend="Contrato">
                                <FormGrid>
                                    <FormField >
                                        <Label>Código</Label>
                                        <Input
                                            type="text"
                                            name="sd42numcontrato"
                                            value={formData.sd42numcontrato?.toString() ?? ""}
                                            validation="numbers"
                                            disabled
                                        />
                                    </FormField>
                                    <InputData
                                        name="sd42dtcontrato"
                                        initialValue={formData.sd42dtcontrato}
                                        label="Data"
                                        disabled
                                    />
                                </FormGrid>
                            </Fieldset>
                            <Separador />
                            <Fieldset legend="Cliente Licenciado">
                                <FormField>
                                    <Label>Cliente</Label>
                                    <Input
                                        name="sd42cliente"
                                        value={`${formData.sd42cliente?.sd40cnpj ?? ""} - ${formData.sd42cliente?.sd40nome ?? ""}`}
                                        disabled
                                    />

                                </FormField>
                                <FormGrid itemsLinha={3}>
                                    <FormField >
                                        <Label>Contato</Label>
                                        <Input
                                            type="text"
                                            name="sd42cliente.sd40contato"
                                            value={formData.sd42cliente?.sd40contato}
                                            onChange={() => { }}
                                            disabled
                                        />
                                    </FormField>
                                    <FormField >
                                        <Label>DDD</Label>
                                        <Input
                                            type="text"
                                            name="sd42cliente.sd40ddd1"
                                            value={formData.sd42cliente?.sd40ddd1}
                                            onChange={() => { }}
                                            disabled
                                        />
                                    </FormField>
                                    <FormField >
                                        <Label>Telefone</Label>
                                        <Input
                                            type="text"
                                            name="sd42cliente.sd40fone1"
                                            value={formData.sd42cliente?.sd40fone1}
                                            onChange={() => { }}
                                            disabled
                                        />
                                    </FormField>
                                </FormGrid>
                            </Fieldset>
                            <Separador />
                            <Fieldset legend="Representante">
                                <FormField>
                                    <Label>Representante</Label>
                                    <Input
                                        name="sd42representante"
                                        value={formData.sd42representante?.sd41nome ?? ""}
                                        disabled
                                    />
                                </FormField>
                            </Fieldset>
                        </Col>
                        <Col md={6} sm={12}>
                            <Row>
                                <Col md={6} sm={12}>
                                    <Fieldset legend="Formais">
                                        <FormGrid>
                                            <FormField >
                                                <Label>Aquisição</Label>
                                                <Input
                                                    type="text"
                                                    name="sd42aquisicao"
                                                    value={formData.sd42aquisicao?.toString() ?? ""}
                                                    onChange={handleChange}
                                                    validation="numbers"
                                                    disabled={!inEdicao}
                                                />
                                            </FormField>
                                            <FormField >
                                                <Label>Locação</Label>
                                                <Input
                                                    type="text"
                                                    name="sd42locacao"
                                                    value={formData.sd42locacao?.toString() ?? ""}
                                                    onChange={handleChange}
                                                    validation="numbers"
                                                    disabled={!inEdicao}
                                                />
                                            </FormField>
                                        </FormGrid>
                                    </Fieldset>
                                </Col>
                                <Col md={6} sm={12}>
                                    <Fieldset legend="Provisória">
                                        <FormGrid>
                                            <FormField >
                                                <Label>Qtde</Label>
                                                <Input
                                                    type="text"
                                                    name="sd42quantidade"
                                                    value={formData.sd42quantidade?.toString() ?? ""}
                                                    onChange={handleChange}
                                                    validation="numbers"
                                                    disabled={!inEdicao}
                                                />
                                            </FormField>
                                            <InputData
                                                name="sd42vencimento"
                                                initialValue={formData.sd42vencimento}
                                                label="Vencimento"
                                                onChange={(value) => handleChangeData(value, "sd42vencimento")}
                                                disabled={!inEdicao}
                                            />
                                        </FormGrid>
                                    </Fieldset>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: '15px' }}>
                                <Col>
                                    <Fieldset legend="SAMPalm">
                                        <FormGrid>
                                            <FormField >
                                                <Label>Android</Label>
                                                <Input
                                                    type="number"
                                                    name="sd42sampalmandroid"
                                                    value={formData.sd42sampalmandroid?.toString() ?? ""}
                                                    onChange={handleChange}
                                                    validation="numbers"
                                                    disabled={!inEdicao}
                                                />
                                            </FormField>
                                            <FormField >
                                                <Label>Ios</Label>
                                                <Input
                                                    type="number"
                                                    name="sd42sampalmios"
                                                    value={formData.sd42sampalmios?.toString() ?? ""}
                                                    onChange={handleChange}
                                                    validation="numbers"
                                                    disabled={!inEdicao}
                                                />
                                            </FormField>
                                        </FormGrid>
                                    </Fieldset>
                                </Col>
                            </Row>
                            <Separador />
                            <Fieldset legend="Licenças">
                                <Fieldset legend="Validação">
                                    <FormField >
                                        <Label>Chave da licença</Label>
                                        <Input
                                            type="text"
                                            name="sd42chave"
                                            value={formData.sd42chave?.toString() ?? ""}
                                            disabled
                                        />
                                    </FormField>
                                    <Fieldset legend="Bloqueio">
                                        <FormGrid>
                                            <InputData
                                                name="sd42dtbloqueio"
                                                initialValue={formData.sd42dtbloqueio}
                                                label="Data"
                                                disabled
                                            />
                                            <FormField >
                                                <Label>Motivo</Label>
                                                <Input
                                                    type="text"
                                                    name="sd42motivobloqueio"
                                                    value={formData.sd42motivobloqueio?.toString() ?? ""}
                                                    disabled

                                                />
                                            </FormField>
                                        </FormGrid>
                                    </Fieldset>
                                </Fieldset>
                                <Fieldset legend="Percentuais">
                                    <FormGrid>
                                        <FormField >
                                            <Label>Desconto</Label>
                                            <Input
                                                type="text"
                                                name="sd42desconto"
                                                value={formData.sd42desconto?.toString() ?? ""}
                                                onChange={handleChange}
                                                validation="numbers"
                                                disabled={!inEdicao}
                                            />
                                        </FormField>
                                        <FormField >
                                            <Label>Relevância</Label>
                                            <Input
                                                type="text"
                                                name="sd42relevancia"
                                                value={formData.sd42relevancia?.toString() ?? ""}
                                                onChange={handleChange}
                                                validation="numbers"
                                                disabled={!inEdicao}
                                            />
                                        </FormField>
                                    </FormGrid>
                                </Fieldset>
                                <Fieldset legend="Servidor SAMPalm">
                                    <FormGrid>
                                        <FormField >
                                            <Label>Servidor SAMPalm</Label>
                                            <Input
                                                type="text"
                                                name="sd42servidorsam"
                                                value={formData.sd42servidorsam?.toString() ?? ""}
                                                onChange={handleChange}
                                                disabled={!inEdicao}
                                            />
                                        </FormField>
                                    </FormGrid>
                                </Fieldset>
                            </Fieldset>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: '25px' }}>
                        <TableContainer>
                            <Table>
                                <thead>
                                    <tr>
                                        <Th>#</Th>
                                        <Th>sigla</Th>
                                        <Th>Sistema</Th>
                                        <Th>Valor</Th>
                                        <Th>Aquis.</Th>
                                        <Th>Locaç.</Th>
                                        <Th>Total</Th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData.sd421s?.map(sd421 => (
                                        <tr key={sd421.sd421id}>
                                            <Td>{sd421.sd421id}</Td>
                                            <Td>{sd421.sd421sistema.sd11sigla}</Td>
                                            <Td>{sd421.sd421sistema.sd11descr}</Td>
                                            <Td>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(sd421.sd421sistema.sd11preco ?? 0)}</Td>
                                            <Td>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(sd421.valorAquisicao ?? 0)}</Td>
                                            <Td>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(sd421.valorLocacao ?? 0)}</Td>
                                            <Td>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(sd421.valorTotal ?? 0)}</Td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </TableContainer>
                    </Row>

                    <RowBtn>
                        <Col md="2">
                            {
                                inEdicao ? (
                                    <div>
                                        <ButtonSecundary type="button" onClick={handleCancelar} >
                                            Cancelar
                                        </ButtonSecundary>
                                        <ButtonPrimary type="submit">
                                            Salvar
                                        </ButtonPrimary>
                                    </div>
                                ) : (
                                    <div>
                                        <ButtonPrimary type="button" onClick={handleEdit} disabled={!credencialTemAcesso("licenças", "sd031edita")}>
                                            Editar
                                        </ButtonPrimary>
                                    </div>
                                )
                            }
                        </Col>
                        <Col>
                            {
                                !inEdicao && (
                                    <ButtonPrimary type="button" onClick={toggleModalBloquear} disabled={!credencialTemAcesso("licenças", "sd031edita")}>
                                        Bloquear
                                    </ButtonPrimary>
                                )
                            }
                        </Col>
                    </RowBtn>
                    <UltAlt>Ultima alteração: {formData.sd42du}</UltAlt>
                </form>

                <Modal isOpen={isModalBloquioOpen} toggle={toggleModalBloquear} centered>
                    <ModalHeader toggle={toggleModalBloquear}>Bloqueio</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <InputData
                                    name="sd42dtbloqueio"
                                    initialValue={formDataBloquio.sd42dtbloqueio}
                                    label="Data"
                                    onChange={(value) => handleChangeDataBloqueio(value, "sd42dtbloqueio")}
                                />
                            </Col>
                            <Col>
                                <FormField >
                                    <Label>Motivo</Label>
                                    <Input
                                        type="text"
                                        name="sd42motivobloqueio"
                                        value={formDataBloquio.sd42motivobloqueio?.toString() ?? ""}
                                        onChange={handleChangeBloquio}
                                    />
                                </FormField>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <ButtonPrimary type="button" onClick={handleDesbloquear}>
                            Desbloquear
                        </ButtonPrimary>
                        <ButtonPrimary type="button" onClick={handleSubmitBloquio}>
                            Bloquear
                        </ButtonPrimary>
                    </ModalFooter>
                </Modal>
            </FormContainer>
        </AppLayout>
    )
}

const Separador = styled.div`
    margin-bottom: 15px;
`

const RowBtn = styled(Row)`
    margin-top: 15px;
`